import type { StatusResponse } from '@status/shared';

const BASE = (import.meta.env['VITE_API_BASE_URL'] ?? '').replace(/\/+$/, '');

export type Period = '1h' | '24h' | '7d' | '30d';

export const DEFAULT_PERIOD: Period = '1h';

export const PERIODS: readonly { value: Period; label: string }[] = [
  { value: '1h', label: '1 小时' },
  { value: '24h', label: '24 小时' },
  { value: '7d', label: '7 天' },
  { value: '30d', label: '30 天' },
];

export async function fetchStatus(period: Period, signal?: AbortSignal): Promise<StatusResponse> {
  const res = await fetch(`${BASE}/api/status?period=${period}`, {
    signal,
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body: unknown = await res.json();
      const msg = (body as { error?: { message?: unknown } }).error?.message;
      if (typeof msg === 'string') detail = msg;
    } catch {
      // 响应不是 JSON，保留 HTTP 状态码
    }
    throw new Error(detail);
  }

  return (await res.json()) as StatusResponse;
}
